var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
import filterReactProps from "filter-react-props";
var Box = function Box(_ref) {
  var _ref$is = _ref.is,
    Component = _ref$is === undefined ? "div" : _ref$is,
    width = _ref.width,
    height = _ref.height,
    props = _objectWithoutProperties(_ref, ["is", "width", "height"]);
  return React.createElement(Component, filterReactProps(props));
};
Box.is = function (is) {
  return function (props) {
    return React.createElement(Box, _extends({
      is: is
    }, props));
  };
};
export default Box;